<script>
import vuetableFormatter from '@src/mixins/vuetableFormatters'
import checkinCheckoutPhotoReportTypes from '@src/mixins/checkinCheckoutPhotoReportTypes'

const i18nKey = 'CHECKIN_CHECKOUT_PHOTO_REPORTS'

export default {
    mixins: [
        vuetableFormatter,
        checkinCheckoutPhotoReportTypes,
    ],
    data() {
        return {
            checkinCheckoutPhotoReportFields: [
                {
                    name: 'filtered_start',
                    title: this.getI18n(i18nKey, 'FIELDS.filtered_start'),
                    sortField: 'filtered_start',
                },
                {
                    name: 'filtered_end',
                    title: this.getI18n(i18nKey, 'FIELDS.filtered_end'),
                    sortField: 'filtered_end',
                },
                {
                    name: 'type',
                    title: this.getI18n(i18nKey, 'FIELDS.type'),
                    order: 'type',
                    formatter: (value) => {
                        const type = this.exportTypes.find(
                            (type) => type.value === value
                        )
                        return type.text
                    },
                },
                {
                    name: 'order',
                    title: this.getI18n(i18nKey, 'FIELDS.order'),
                    order: 'order',
                    formatter: (value) => {
                        const order = this.exportOrders.find(
                            (option) => option.value === value
                        )
                        return order.text
                    },
                },
                {
                    name: 'creator_name',
                    title: this.getI18n(i18nKey, 'FIELDS.creator'),
                    sortField: 'creator_name',
                },
                {
                    name: 'started',
                    title: this.getI18n(i18nKey, 'FIELDS.started'),
                    sortField: 'started_at_date_time',
                },
                {
                    name: 'ended',
                    title: this.getI18n(i18nKey, 'FIELDS.ended'),
                    sortField: 'ended_at_date_time',
                },
                {
                    name: 'file',
                    title: this.getI18n(i18nKey, 'FIELDS.file'),
                },
            ],
        }
    },
}
</script>
